export default __webpack_public_path__ + "static/blob10-585e8db32ef6b987489a8648a6d5905a.svg";